import "./registerServiceWorker";

import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import httpInstance from "./http-instance";

Vue.config.productionTip = false;

Vue.prototype.$http = httpInstance;
store.$http = httpInstance

new Vue({
  store,
  router,
  vuetify,
  render: function(h) {
    return h(App);
  },
}).$mount("#app");
